import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface FinancialEntityNameParams extends DefaultHttpHeaders {
  financialEntityCode: string;
}

@Injectable()
export class FinancialEntityNameService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining financial entity by code
   * Service for obtaining financial entity by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundFinancialEntityNameByCode
   */
  financialEntityName(params: FinancialEntityNameParams): Observable<ParameterResult> {
    const pathParams = {
      financialEntityCode: params.financialEntityCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/financialEntityName/${pathParams.financialEntityCode}`,
    });
  }
}
